import React from 'react';
import { Application } from '../../../../../entities/Application';
import { IconSpan } from '../../../../../components/IconSpan';

interface PropTypes {
  application: Application;
  hideCV?: boolean;
}

function IconLink(props: { icon: string; spanText: string; link: string }) {
  return (
    <div className='d-flex py-1'>
      <a
        href={props.link}
        className='text-info'
        target='_blank'
        rel='noreferrer'
      >
        <IconSpan
          icon={{ name: props.icon, className: 'text-dark-200' }}
          spanText={props.spanText}
        />
      </a>
    </div>
  );
}

export function PortfolioAndCVAndCoverLetter(props: PropTypes) {
  return (
    <div className='fs-5'>
      {!props.hideCV && props.application.applicationResume && (
        <IconLink
          icon='bi-file-text'
          spanText='View CV'
          link={props.application.applicationResume.url}
        />
      )}
      {props.application.portfolioUrl && (
        <IconLink
          icon='bi-laptop'
          spanText='View Portfolio'
          link={props.application.portfolioUrl}
        />
      )}
      {props.application.applicationCoverLetter && (
        <IconLink
          icon='bi-file-earmark-text'
          spanText='View Cover Letter'
          link={props.application.applicationCoverLetter.url}
        />
      )}
    </div>
  );
}
